import { motion } from "framer-motion";
import { Star } from "lucide-react";

const MAPS_URL = "https://maps.app.goo.gl/7rfrjApLiapbM7PJ8";

const reviews = [
  {
    name: "Daniel Markley-Lopez",
    date: "A month ago",
    quote:
      "A comprehensive recovery powerhouse with everything you need to feel your best — from top-tier cold plunges and infrared saunas to PEMF and hyperbaric oxygen. Owner Brian has built a welcoming, high-performance community that feels personal rather than corporate. I cannot recommend this team highly enough."
  },
  {
    name: "Damien Tillman",
    date: "3 weeks ago",
    quote:
      "Great place for my boys to recover after all of their basketball tournaments. Very relaxing environment and the staff knew exactly what the boys needed."
  },
  {
    name: "Scott G",
    date: "A month ago",
    quote:
      "This is the best wellness and recovery studio in the valley. Amazing options at an amazing price — hyperbaric chamber, cold plunge, red light, compression, sauna, PEMF and float."
  }
];

const Stars = () => (
  <div className="flex gap-1" aria-label="5 out of 5 stars">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-rest-red text-rest-red" />
    ))}
  </div>
);

export const Reviews = () => (
  <section className="mx-auto max-w-7xl px-5 py-28 md:px-10 md:py-40" data-testid="reviews-section">
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8 }}
      className="mb-16 flex flex-col gap-6 md:flex-row md:items-end md:justify-between"
    >
      <div>
        <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-rest-blue">Member reviews</p>
        <h2 className="font-display text-4xl font-black uppercase tracking-tighter md:text-6xl">
          Five stars.<br />Every time.
        </h2>
      </div>
      <a
        href={MAPS_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="reviews-google-link"
        aria-label="Read all Google reviews for REST Recovery Wellness North Phoenix"
        className="group flex items-center gap-4 border border-white/15 px-6 py-4 transition-colors duration-300 hover:border-white/50"
      >
        <span className="font-display text-4xl font-black tracking-tighter text-rest-red">5.0</span>
        <span className="font-mono text-[10px] uppercase leading-relaxed tracking-[0.2em] text-zinc-400">
          17 Google reviews<br />
          <span className="text-white transition-colors duration-300 group-hover:text-rest-red">Read them all</span>
        </span>
      </a>
    </motion.div>

    <div className="grid gap-5 md:grid-cols-3">
      {reviews.map((r, i) => (
        <motion.figure
          key={r.name}
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col justify-between border border-white/10 bg-rest-surface p-8 transition-colors duration-500 hover:border-rest-red/40"
          data-testid={`review-card-${i}`}
        >
          <div>
            <Stars />
            <blockquote className="mt-6 text-sm leading-relaxed text-zinc-300 md:text-base">
              "{r.quote}"
            </blockquote>
          </div>
          <figcaption className="mt-8 border-t border-white/10 pt-5">
            <p className="font-display text-sm font-bold uppercase tracking-tight">{r.name}</p>
            <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">
              {r.date} — Verified Google review
            </p>
          </figcaption>
        </motion.figure>
      ))}
    </div>
  </section>
);
